const isDemoWedding = weddingId => weddingId === 'demo';

export default isDemoWedding;
